import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Wine, UtensilsCrossed, Wind } from 'lucide-react';
export function Daytime() {
  const features = [{
    icon: Wine,
    title: 'Premium Cocktails',
    description: 'Handcrafted signature drinks made with top-shelf spirits and fresh ingredients.'
  }, {
    icon: UtensilsCrossed,
    title: 'Gourmet Dining',
    description: 'A culinary journey featuring artisanal dishes prepared by our world-class chefs.'
  }, {
    icon: Wind,
    title: 'Premium Hookah',
    description: 'An extensive selection of premium flavors served in a luxurious setting.'
  }];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1216">
      <Header data-id="element-1217" />

      {/* Hero Section */}
      <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-1218">
        {/* Background */}
        <div className="absolute inset-0 z-0" data-id="element-1219">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014] via-[#0B1014]/50 to-[#0B1014] z-10" data-id="element-1220" />
          <img src="https://cdn.magicpatterns.com/uploads/xk9CNNkWNr8YNTct87fWbi/SnapInsta.to_682077530_18095301950328170_9178311643633562905_n.jpg" alt="Daytime Dining" className="w-full h-full object-cover opacity-60" data-id="element-1221" />
        </div>

        {/* Content */}
        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto" data-id="element-1222">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1223">
            <div className="inline-block mb-6" data-id="element-1224">
              <span className="text-[#DDA247] text-sm font-bold uppercase tracking-[0.3em] border border-[#DDA247] px-6 py-2" data-id="element-1225">
                11AM - 5PM
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-12 tracking-tight" data-id="element-1226">
              DAYTIME
            </h1>

            <Link to="/book-now" data-id="element-1227">
              <Button size="lg" className="min-w-[200px]" data-id="element-1228">
                RESERVE TABLE
              </Button>
            </Link>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20" data-id="element-1229">
          <div className="w-[1px] h-24 bg-gradient-to-b from-transparent via-[#DDA247] to-transparent animate-pulse" data-id="element-1230" />
        </motion.div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 px-4 md:px-8 bg-[#0B1014]" data-id="element-1231">
        <div className="max-w-7xl mx-auto" data-id="element-1232">
          <div className="text-center mb-20" data-id="element-1233">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-1234">
              Gourmet dining, sports viewing, and premium hookah in a
              sophisticated atmosphere.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1235">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} className="bg-[#11161A] border border-white/10 p-10 text-center group hover:border-[#DDA247] transition-colors duration-300" data-id="element-1236">
                <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300" data-id="element-1237">
                  <feature.icon className="w-10 h-10 text-[#DDA247]" data-id="element-1238" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 tracking-wide" data-id="element-1239">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-1240">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-1241" />
    </div>;
}